import React, { Fragment } from "react";

import img13 from "../../../images/service/Social Media Blockchain Development/1.png";
import img14 from "../../../images/service/Social Media Blockchain Development/2.png";
import img15 from "../../../images/service/Social Media Blockchain Development/3.png";
// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Decentralized Social Platforms",
    content:
      "We build blockchain-powered social networks that eliminate centralized control and empower users.",
  },
  {
    icon: sIcon2,
    title: "Creator Monetization Systems",
    content:
      "Enable creators to earn directly through tokens, NFTs, and decentralized reward mechanisms.",
  },
  {
    icon: sIcon3,
    title: "User Data Ownership",
    content:
      "Give users full control over their content, identity, and personal data using blockchain.",
  },
];

const benefits = [
  {
    title: "Data Privacy & Control",
    description:
      "Blockchain ensures users own their data instead of centralized platforms.",
    icon: sIcon1,
  },
  {
    title: "Censorship Resistance",
    description:
      "Decentralized architecture prevents arbitrary content removal or platform bans.",
    icon: sIcon2,
  },
  {
    title: "Fair Monetization",
    description:
      "Creators earn directly without intermediaries taking large revenue cuts.",
    icon: sIcon3,
  },
  {
    title: "Transparent Governance",
    description:
      "Community-driven governance models ensure platform transparency and fairness.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is blockchain-based social media?",
    a: "Blockchain-based social media platforms are decentralized networks where users control their data, content, and monetization.",
  },
  {
    q: "How does blockchain improve user privacy?",
    a: "Blockchain removes centralized data storage and enables secure, user-owned identities.",
  },
  {
    q: "Can creators earn money on blockchain social platforms?",
    a: "Yes. Creators can monetize through tokens, NFTs, subscriptions, and community rewards.",
  },
  {
    q: "Is blockchain social media scalable?",
    a: "Modern blockchain solutions are designed to support high user activity with scalable architectures.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function SocialMediaBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Social Media Blockchain Development"
        pagesub="Decentralized, secure & user-owned social platforms"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Redefine Social Networking with{" "}
            <span className="gradient-text">Blockchain Technology</span>
          </>
        }
        subtitle={`Build next-generation social media platforms that prioritize privacy,
creator freedom, and transparent monetization using blockchain.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Social Media Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Blockchain for Social Media?"
        image={img14}
        paragraphs={[
          "Traditional social media platforms are centralized, controlling user data, content visibility, and monetization. This often leads to privacy concerns, unfair revenue distribution, and censorship.",
          "Blockchain introduces decentralization, giving users and creators full ownership of their data while enabling transparent and fair digital interactions.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Social Media Blockchain Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Challenges with Traditional Social Media Platforms"
        image={img15}
        paragraphs={[
          "Centralized platforms store massive amounts of user data, making them vulnerable to breaches, misuse, and manipulation.",
          "Blockchain-powered social media eliminates these risks by distributing control across decentralized networks.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Blockchain Social Media Platforms"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Blockchain-Based Social Platforms"
        subtitle="Designed for privacy, fairness, and creator empowerment"
        features={[
          {
            icon: sIcon1,
            title: "Decentralized Identity",
            description:
              "Users control their digital identities without relying on centralized authorities.",
          },
          {
            icon: sIcon2,
            title: "Tokenized Rewards",
            description:
              "Engagement-based rewards powered by blockchain tokens.",
          },
          {
            icon: sIcon3,
            title: "NFT-Based Content",
            description:
              "Creators can tokenize posts, videos, and digital assets as NFTs.",
          },
          {
            icon: sIcon4,
            title: "Community Governance",
            description:
              "DAO-based governance models ensure community-driven decisions.",
          },
          {
            icon: sIcon5,
            title: "End-to-End Encryption",
            description:
              "Secure messaging and data sharing using cryptographic protocols.",
          },
          {
            icon: sIcon6,
            title: "Scalable Infrastructure",
            description:
              "High-performance blockchain networks support large user bases.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Expertise in decentralized social platforms",
          "Strong focus on privacy and user ownership",
          "End-to-end blockchain development support",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
